module.exports = __webpack_public_path__ + "img/road-exclusions-image-placeholder.9044c051.png";